import type { SortingConfiguration } from 'vue-instantsearch/vue3/es';
import type { IVueI18n } from 'vue-i18n';
import { i18nToTypesenseMainIndex } from '../locales/i18nCurrentDetails';
import { SORTING_METHODS } from '~~/constants/typesense';
import { TYPESENSE_SORTING_TYPE_SPLIT } from '~~/constants/regex';

/**
 * typesense expects the sorting value to be something like
 * "whatever-term-here/sort/price:asc" so that the adapter will extract only
 * "price:asc"
*/
export const generateTypesenseSortingIndex = (searchIndex: string, sortingType: string) => {

  let sortingNameForTypesense = '';

  if (sortingType === 'newest') {

    sortingNameForTypesense = '_eval(inStock:true):desc,releaseDate:desc';

  } else {

    sortingNameForTypesense = sortingType.split(TYPESENSE_SORTING_TYPE_SPLIT).join(':').toLowerCase();

  }

  return `${searchIndex}/sort/${sortingNameForTypesense}`;

};

export const getTypesenseSortingConfiguration = ($i18n: IVueI18n): SortingConfiguration[] => {

  const mainSearchIndex = i18nToTypesenseMainIndex($i18n);

  return SORTING_METHODS.map((sorting) => {

    const sortingValue = (() => {

      if (!sorting.value) {

        return mainSearchIndex;

      }

      if (sorting.value.includes(mainSearchIndex)) {

        return sorting.value;

      }

      return generateTypesenseSortingIndex(mainSearchIndex, sorting.value);

    })();

    return {
      ...sorting,
      label: $i18n.t(sorting.label),
      value: sortingValue,
    };

  });

};
